/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Sortingasc1Inputs */

const en__field_sortingasc1 = /** @type {(inputs: _Field_Sortingasc1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ascending`)
};

const de__field_sortingasc1 = /** @type {(inputs: _Field_Sortingasc1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aufsteigend`)
};

/**
* | output |
* | --- |
* | "Ascending" |
*
* @param {_Field_Sortingasc1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_sortingasc1 = /** @type {((inputs?: _Field_Sortingasc1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Sortingasc1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_sortingasc1(inputs)
	return de__field_sortingasc1(inputs)
});
export { _field_sortingasc1 as "_field_sortingAsc" }